export const getContentDocumentChild = (schematicsRef, selector) => {
  let element;
  try {
    const objectContentDocument =
      schematicsRef.current.querySelector('object').contentDocument;
    element = objectContentDocument.querySelectorAll(selector);
  } catch (error) {
    element = null;
  }
  return element;
};

export const setHighlight = (callout, onFocus, isCurrentPDPPart = false) => {
  if (!onFocus) {
    document.activeElement.blur();
  }
  Array.prototype.forEach.call(callout, element => {
    const highlight = document.createElementNS(
      'http://www.w3.org/2000/svg',
      'circle'
    );
    const textLength = element.textContent.length;

    const highlightName = isCurrentPDPPart
      ? 'schematicsDiagramStaticPartHighlight'
      : 'schematicsDiagramPartHighlight';

    const highlightFill = isCurrentPDPPart ? '#FFCC00' : '#000000';

    const elementFill = isCurrentPDPPart ? '#000000' : '#ffffff';

    highlight.setAttribute('name', highlightName);
    highlight.setAttribute('cx', `${3 * textLength}`);
    highlight.setAttribute('cy', '5');
    highlight.setAttribute('r', '15');
    highlight.setAttribute('stroke', '#000000');
    highlight.setAttribute('stroke-width', '1');
    highlight.setAttribute('fill', highlightFill);
    highlight.setAttribute('cx', `${3 * textLength}`);
    highlight.setAttribute(
      'transform',
      element.getAttribute('transform') ?? ''
    );
    element.parentNode.insertBefore(highlight, element);
    element.setAttribute(
      'style',
      `font-size: 14px; fill: ${elementFill}; font-weight: bold;`
    );
  });
};

export const deactivateHighlight = schematicsRef => {
  const elements = getContentDocumentChild(
    schematicsRef,
    '[name=schematicsDiagramPartHighlight]'
  );

  if (elements && elements.length > 0) {
    Array.prototype.forEach.call(elements, element => {
      const parentNode = element.parentNode;
      element.parentNode.removeChild(element);
      parentNode.lastElementChild.setAttribute('style', '');
    });
  }
};

export const activateHighlight = (
  schematicsRef,
  referenceNumber,
  onFocus = false,
  isCurrentPDPPart = false
) => {
  const calloutLegacy = getContentDocumentChild(
    schematicsRef,
    `[id^=ID_${referenceNumber}_] > text`
  );
  const callout = getContentDocumentChild(
    schematicsRef,
    `[data-callout='${referenceNumber}'] > text`
  );

  if (callout && callout.length > 0) {
    setHighlight(callout, onFocus, isCurrentPDPPart);
  } else if (calloutLegacy && calloutLegacy.length > 0) {
    setHighlight(calloutLegacy, onFocus, isCurrentPDPPart);
  }
};

export default { activateHighlight, deactivateHighlight };
